const messages = {
  step3: {
    actionBtn: "Anmelden",
  },
};

export default {
  messages,
};
